module.exports = function () {
    return window;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jpex-web/src/$window.js
// module id = wxyV
// module chunks = 0